import script from "./AddAnMail.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddAnMail.vue?vue&type=script&setup=true&lang=ts"

import "./AddAnMail.vue?vue&type=style&index=0&id=bdd462a6&lang=css"

const __exports__ = script;

export default __exports__